import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CustomModalService } from '@piqet-angular/shared';
import { customEncode, encrypt } from 'libs/shared/src/lib/service/helper.service';

@Injectable({
  providedIn: 'root',
})
export class EolNavigationService {
  constructor(private route: Router, private modal: CustomModalService) {}

  eolAction(
    componentName: string,
    inValidScenarios: any[],
    projectId: number,
    navigateFn: (scenario: any, link?: string) => void
  ): void {
    if (inValidScenarios?.length <= 1) {
      navigateFn(inValidScenarios[0]);
    } else {
      this.modal.invoke('invalidEolScenarioComponent', {
        initialState: {
          list: inValidScenarios,
          projectId: projectId,
          componentName: componentName,
        },
        class: 'modal-lg',
      });
    }
  }

  navigateToScenario(scenario: any, projectId: number, link: string = 'end-of-life'): void {
    const valueToEncrypt = `{ "id": ${
      link == 'fill-data-list' ? scenario.packageScenarioId : scenario.scenarioId
    }, "packageScenarioId": ${scenario.packageScenarioId}, "eId": ${scenario.scenarioId}}`;
    const encryptedValue = encrypt(valueToEncrypt);
    const encodedValue = encodeURIComponent(projectId.toString());
    const urlTree = this.route.createUrlTree(
      [`projects/projects-setting/${customEncode(btoa(encodedValue))}/${link}`],
      { queryParams: { param: encryptedValue } }
    );
    const url = this.route.serializeUrl(urlTree);
    const fullUrl = `/#${url}`;
    window.open(fullUrl, '_blank');

    this.modal.close();
  }
}
